export const BACKEND_BASE_URL = 'https://apiv2.smart378.it';
export const STORAGE_URL = BACKEND_BASE_URL + '/attachment';
export const API_BASE_URL = BACKEND_BASE_URL + '/api/v2';